module.exports = __webpack_public_path__ + "static/crime-and-punishment-83a5b87f632cd263f8edaf7225b2a210.jpg";